import { AfterContentInit, AfterViewInit, Component, ContentChild, ElementRef, Input, OnDestroy, ViewChild, TemplateRef, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';

import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';

import { escape, isString } from 'rev-shared/util';
import { VbUiDataGridComponent } from 'rev-shared/ui/dataGrid/VbUiDataGrid.Component';
import { VbUiInfiniteScrollGridComponent } from 'rev-shared/ui/dataGrid/infiniteScroll/VbUiInfiniteScrollGrid.Component';

import { GridType } from './Constant';

import styles from './ReportGridWrapper.Component.module.less';

const MIN_SEARCH_LENGTH: number = 2;
const SEARCH_DEBOUNCE_MS: number = 500;

@Component({
	selector: 'report-grid-wrapper',
	templateUrl: './ReportGridWrapper.Component.html',
	host: {
		class: 'height-full width-full',
		layout: 'column',
		'layout-wrap': 'false'
	},
	standalone: false
})
export class ReportGridWrapperComponent implements OnInit, AfterContentInit, AfterViewInit, OnDestroy {
	@Input() public accountId: string;
	@Input() public header: string;
	@Input() public headerTag: string;
	@Input() public headerTemplate: TemplateRef<any>;
	@Input() public isInfiniteScroll: boolean;
	@Input() public pollingIntervalSecs: number;
	@Input() public type: GridType;

	@ContentChild(VbUiDataGridComponent) public normalGrid: VbUiDataGridComponent;
	@ContentChild(VbUiDataGridComponent, { read: ElementRef }) private gridElement: ElementRef<HTMLElement>;

	@ContentChild(VbUiInfiniteScrollGridComponent) public infiniteGrid: VbUiInfiniteScrollGridComponent;
	@ContentChild(VbUiInfiniteScrollGridComponent, { read: ElementRef }) private readonly infiniteGridElement: ElementRef<HTMLElement>;

	@ViewChild('searchInputNgModel') private readonly searchInput: NgModel;

	public searchInputValue: string;
	public readonly styles = styles;
	public readonly escape = escape;
	public grid: VbUiDataGridComponent | VbUiInfiniteScrollGridComponent;
	public gridProperties: any = {};

	private subscriptions: Subscription[];

	public ngOnInit(): void {
		this.setGridProperties();
	}

	public ngAfterContentInit(): void {
		this.grid = this.normalGrid || this.infiniteGrid;
		this.gridElement = this.gridElement || this.infiniteGridElement;

		this.gridElement.nativeElement.setAttribute('flex', 'fill');
		this.gridElement.nativeElement.classList.add('height-full');
	}

	public ngAfterViewInit(): void {
		this.subscriptions = [
			this.initSearchInputSubscription()
		];
	}

	public ngOnDestroy(): void {
		this.subscriptions?.forEach(sub => sub.unsubscribe());
	}

	private setGridProperties(): void {
		this.gridProperties = {
			context: {
				accountId: this.accountId,
				type: this.type
			},
			options: {
				suppressMultiSort: true,
				accentedSort: true
			},
			defaultColDef: {
				minWidth: 270,
				resizable: true
			}
		};
	}


	private initSearchInputSubscription(): Subscription {
		return this.searchInput.valueChanges
			.pipe(
				filter(text => isString(text)),
				map(text => text.trim()),
				filter(text => !text.length || text.length >= MIN_SEARCH_LENGTH),
				debounceTime(SEARCH_DEBOUNCE_MS),
				distinctUntilChanged()
			)
			.subscribe(value => this.grid.setQuickFilterText(value));
	}
}
